module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-top"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-5 is-offset-custom-home-desktop"
  }, [_c('article', {
    staticClass: "tile is-child box bottom-padding-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedfiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list"
  }, [(_vm.next > 0) ? _c('li', {
    staticClass: "pagination-next",
    on: {
      "click": function($event) {
        _vm.next -= 1;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })]) : _vm._e(), _vm._v(" "), _vm._l(((Math.ceil(_vm.pagetop / 10))), function(n) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (n <= (_vm.next + 1) * 5 && n > _vm.next * 5),
        expression: "n<=(next+1)*5 && n>next*5"
      }],
      staticClass: "pagination-next ",
      on: {
        "click": function($event) {
          _vm.fetchPage(n, $event)
        }
      }
    }, [_vm._v(_vm._s(n) + "\n          ")])
  }), _vm._v(" "), ((_vm.next + 1) * 5 < Math.ceil(_vm.pagetop / 10)) ? _c('li', {
    staticClass: "pagination-next",
    on: {
      "click": function($event) {
        _vm.next += 1;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right"
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-5"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.popularfiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-10 is-offset-custom-home-desktop"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        _vm.searchFiles()
      }]
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary"
  }, [_vm._v(" Search")])]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.searchedfiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(file.downloads))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Uploads")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("DLs")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Popular Uploads")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("DLs")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" File Search")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', {
    staticClass: "no-break-word"
  }, [_vm._v("DLs")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5d96b83a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 157
// module chunks = 34